export const AEM_DEVICE_SETTINGS_TYPES = {
    AUTO_START: 'AUTO_START',
    FLEX_BATTERY: 'FLEX_BATTERY',
    FLEX_PUFF: 'FLEX_PUFF',
    ILLUMINATION_MODE: 'ILLUMINATION_MODE',
    LOCK_UNLOCK: 'LOCK_UNLOCK',
    PAUSE_MODE: 'PAUSE_MODE',
    REMAINING_STICKS: 'REMAINING_STICKS',
    SMART_GESTURES: 'SMART_GESTURES',
    VIBRATIONS: 'VIBRATIONS',
};
